<template>
  <div>
    <div class="col-md-12">
      <div class="card" v-if="activeProcess">
        <div class="card-header">
          <h4 class="card-title">
            <span>Current Grab Job</span>
            &nbsp;
            <span v-if="activeProcess.batch && activeProcess.batch.name">
              <span :class="'label label-'+activeProcess.batch.color">{{activeProcess.batch.name}}</span>
            </span>
          </h4>
        </div>
        <div class="card-body">
          <div>
            <current-job :active-process="activeProcess"/>
          </div>
        </div>
        <div class="card-footer">
          <div class="text-center">
            <button class="btn btn-default btn-fill btn-icon btn-lg" @click="$router.push({name: 'grabjobs.view', params: {id: activeProcess.id} })">
              Show details<i class="ti-angle-right"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="card no-job" v-else>
        <div class="card-content">
          <div class="row">
            <div class="col-md-5">
              <h3>Next Grab Job scheduled in:</h3><br>
              <h1 v-if="generalGrabInfo && generalGrabInfo.next_job_time">
                <span class="label label-info">
                  <countdown :time="generalGrabInfo.next_job_time" v-slot="{ days, hours, minutes, seconds }">
                    {{ hours }}h {{ minutes }}m {{ seconds }}s
                  </countdown>
                </span>
              </h1>
            </div>
            <div class="col-md-2"><em>OR</em></div>
            <div class="col-md-5">
              <h3>Start Grab Job manually:</h3><br>
              <button class="btn btn-fill btn-lg btn-success" @click="submitGrabJobStart">Start Now</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <time-line>
        <time-line-item
          v-for="(process, key) in inactiveProcesses"
          :key="process.id"
          class="timeline"
          :class="{'timeline-inverted': (key+1) % 2 === 0}"
          badgeType="danger"
          badgeIcon="ti-pulse">

          <span slot="header" class="label label-danger">Grab Job from {{ process.created_at }}</span>
          <div slot="body">
            <div class="row">
              <div class="col-md-4">
                <div data-background-color="blue" class="card card-circle-chart">
                  <div class="card-header text-center">
                    <p class="description">Total Runtime</p>
                  </div>
                  <div class="card-content">
                    <div class="chart-circle">{{ process.total_runtime }}</div>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div data-background-color="green" class="card card-circle-chart">
                  <div class="card-header text-center">
                    <p class="description">Channels Processed</p>
                  </div>
                  <div class="card-content">
                    <div class="chart-circle">{{ process.statsGeneral.channelsProcessed }}</div>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div data-background-color="orange" class="card card-circle-chart">
                  <div class="card-header text-center">
                    <p class="description">Average CPU load</p>
                  </div>
                  <div class="card-content">
                    <div data-percent="70" class="chart-circle">{{ process.statsGeneral.averageLoad }}%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div slot="footer">
            <div class="pull-left" v-if="process.batch && process.batch.name">
              <span :class="'label label-'+process.batch.color">{{ process.batch.name }}</span>
            </div>
            <div class="pull-right">
              <button class="btn btn-default btn-fill btn-icon btn-sm" @click="$router.push({name: 'grabjobs.view', params: {id: process.id} })">
                Show details <i class="ti-angle-right"></i>
              </button>
            </div>
          </div>
        </time-line-item>
      </time-line>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import TimeLine from '../Dashboard/Stats/TimeLine.vue'
import TimeLineItem from '../Dashboard/Stats/TimeLineItem.vue'
import CurrentJob from "./List/CurrentJob";
import CircleChartCard from "../../../UIComponents/Cards/CircleChartCard";
import swal from 'sweetalert2'

export default {
  components: {
    CircleChartCard,
    CurrentJob,
    TimeLine,
    TimeLineItem
  },
  async mounted () {
    await this.processFetchList();
    await this.processFetchInfo();
  },
  computed: {
    ...mapGetters(['inactiveProcesses', 'activeProcess', 'generalGrabInfo'])
  },
  methods: {
    ...mapActions(['processFetchList', 'processFetchInfo', 'processStart']),
    submitGrabJobStart: function () {
      const self = this;
      swal({
        title: 'Are you sure?',
        text: 'Grabbing process will be started on all active servers.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Start',
        buttonsStyling: false
      }).then(function () {
        self.processStart();
        swal({
          title: 'Job Started!',
          text: 'Grab job will begin shortly.',
          type: 'success',
          confirmButtonClass: 'btn btn-success btn-fill',
          buttonsStyling: false
        })
      })
    }
  }
}
</script>
<style>
.card.card-transparent {
  background: transparent;
  box-shadow: none;
}

.card.card-transparent .card-footer {
  display: none;
}

.timeline-body .chart-circle {
  line-height: 40px;
  height: 40px;
}

.card.no-job .row > div {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  flex-direction: column;
}

.card.no-job .row > div > h1 {
  margin-top: 15px;
}

.card.no-job .row > div > h3 {
  margin: 0px;
}

.swal2-confirm {
  margin-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/GrabProcess/List.vue